
  export default {
    name: "RefundableSlider",
    props: {
      data: {
        type: Object,
        required: true,
      },
      hasTitle: {
        type: Boolean,
        default: true
      },
      titleText: {
        type: String,
        default: null
      },
      isColumn: {
        type: Boolean,
        default: false
      },
      tollTipOnTop: {
        type: Boolean,
        default: true,
      },
      creationDate: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        policyWidth: null,
        nonRefWidth: null
      };
    },
    methods: {
      setPolicyWidth() {
        if(!this.$refs.policyDescription) {
          return;
        }

        this.policyWidth = this.$refs.policyDescription.$el.clientWidth;
      },
      setNotRefBarWidth() {
        if(!this.$refs.notRefundableStep) {
          return;
        }

        this.nonRefWidth = this.$refs.notRefundableStep.clientWidth;
      },
    },
    mounted() {
      this.setPolicyWidth();
      this.setNotRefBarWidth();
    },
    computed: {
      isActuallyRefundable() {
        return !this.$moment(this.refundableDateLimit).isBefore(this.$moment());
      },
      refundableDateLimit() {
        let startDate = this.$moment(this.data.start_date);
        
        return startDate.subtract(this.data.room_type.refundable_terms + 1, 'days');
      },
      barWidth() {
        let todayToNotRefDate = this.refundableDateLimit.diff(this.$moment(), 'days');
        let todayToStartDate = this.$moment(this.data.start_date).diff(this.$moment(), 'days');

        let firstWidth = (100 / todayToStartDate) * todayToNotRefDate;
        firstWidth = firstWidth <= 10 ? 10 : firstWidth.toFixed(2);

        return [
          firstWidth,
          (100 - firstWidth)
        ];
      },
      barWidthFromConfimrToToday() {
        let todayToNotRefDate = this.refundableDateLimit.diff(this.$moment(), 'days');
        let todayToConfrimDate = this.$moment(this.creationDate).diff(this.$moment(), 'days');

        let firstWidth = (100 / todayToConfrimDate) * todayToNotRefDate;
        firstWidth = firstWidth <= 10 ? 10 : firstWidth.toFixed(2);

        return firstWidth
      },
    }
  };
